import axiosServices from 'utils/axios';
import { UpdatePlayerDto, PlayerDto } from './dto';
import { InsideFifaBackOfficeEndpoints } from '../consts';

export const updatePlayer = async (player: UpdatePlayerDto): Promise<PlayerDto> => {
    try {
        const res = await axiosServices.put<PlayerDto>(`${InsideFifaBackOfficeEndpoints.Players}/${player.id}`, player);

        return res.data;
    } catch (err) {
        throw err;
    }
};
